var _defs, _g, _circle, _path, _path2, _g2, _circle2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailableLocationStandard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.89 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.48,
    y: 12.75,
    width: 15.92,
    height: 15.92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.41,
    y: 5.98,
    width: 11.14,
    height: 11.14,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unavailable-location-standard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.44,43l-4-5.57h8Z",
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.44,
    cy: 21.5,
    r: 17.51,
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.98,
    cy: 11.95,
    r: 11.94,
    fill: "#f9a825"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.44,
    cy: 22.3,
    r: 11.94,
    fill: "#e2ebb9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.89,13.06a11.94,11.94,0,1,0-11,20.12l2.54,3.39L31,33.18a12,12,0,0,0,5.9-20.12ZM30.38,31.68l-.3.06-1.64,2.19L26.8,31.74l-.3-.06a10.37,10.37,0,1,1,3.88,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.45,12.5A12.74,12.74,0,1,0,25.73,34l2.71,3.61L31.15,34a12.74,12.74,0,0,0,6.3-21.46ZM30.51,32.36l-.32.06-1.75,2.33-1.75-2.33-.32-.06a11,11,0,1,1,4.14,0Z",
    fill: "#62c333"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.16,19.17a3.33,3.33,0,0,0-1.17.22,8.52,8.52,0,0,1-.65-1.92,2.16,2.16,0,0,0-2.1-1.72.47.47,0,0,0,0,.94,1.22,1.22,0,0,1,1.06.62l0,.05-.15.25-.73,1.23H25.47l-.22-.56h.09a.46.46,0,0,0,.47-.46.48.48,0,0,0-.47-.47H23.73a.46.46,0,0,0-.46.47.45.45,0,0,0,.46.46h.51l.41,1a3.25,3.25,0,1,0,2.2,4c0-.14.07-.3.1-.45h.86a.45.45,0,0,0,.39-.23l2.46-4.13a12.41,12.41,0,0,0,.51,1.32,3.25,3.25,0,1,0,4.56.58,3.28,3.28,0,0,0-2.57-1.26Zm-9.43,3.72H26A2.32,2.32,0,1,1,26,22H23.73a.45.45,0,0,0-.46.46.46.46,0,0,0,.46.47ZM27.54,22H27a3.25,3.25,0,0,0-1-1.92.43.43,0,0,1,0-.05l-.09-.22h3Zm5.62,2.78a2.31,2.31,0,0,1-2.32-2.31,2.27,2.27,0,0,1,.76-1.71,19.63,19.63,0,0,0,1.17,2,.45.45,0,0,0,.65.1.46.46,0,0,0,.12-.63,18.65,18.65,0,0,1-1.14-1.92,2.31,2.31,0,1,1,1.51,4.37,2.17,2.17,0,0,1-.76.13Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.98,
    cy: 11.96,
    r: 7.96,
    fill: "#f9a825"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.26,8.18l-3.52,5.89a.84.84,0,0,0,.31,1.14.92.92,0,0,0,.4.11h7a.84.84,0,0,0,.82-.85.8.8,0,0,0-.11-.4L42.69,8.18a.85.85,0,0,0-1.15-.28A.93.93,0,0,0,41.26,8.18Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.98,
    y1: 10.32,
    x2: 41.98,
    y2: 11.99,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.98,
    y1: 13.65,
    x2: 41.98,
    y2: 13.65,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableLocationStandard);
export default __webpack_public_path__ + "static/media/unavailable-location-standard.557303b8a7717932ca9435cf7967ed05.svg";
export { ForwardRef as ReactComponent };